import React, { useState } from 'react'
import { FaHome, FaFile, FaFileImport } from "react-icons/fa";
import { IoIosSchool } from "react-icons/io";
import { MdLocalGroceryStore, MdPrivacyTip } from "react-icons/md";
import Content from '../Routing/Content';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Card from './Login_Signup/Card';
import { getDeviceCount, isLoggedIn } from '../Localstorage';
import { useAccessCard } from '../ContextProvider/Accesscardprovider';
import Editprofile from './Login_Signup/Editprofile';
import Toast from '../Notification/Toast';
import GoogleLoginCard from './Login_Signup/GoogleLoginCard';
import { deleteUserByPhone, getAllUsers } from '../Firebase/User-fb';
import { removeDuplicateResults } from '../Firebase/Course-fb';

const Sidebar = ({
    enroll,
    accessEnrollCourse,
    openSidebarToggle,
    OpenSidebar,
    closeBar
}) => {
    const { card, accessCard, showCallReg, accessCallReg, setOpen, toast, setToast, google } = useAccessCard();
    const [activeLink, setActiveLink] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { showProfile } = useAccessCard();

    const handleScrollToFeatured = (section) => {
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
                const featuredSection = document.getElementById(section);
                if (featuredSection) {
                    featuredSection.scrollIntoView({ behavior: "smooth" });
                }
            }, 300);
        } else {
            const featuredSection = document.getElementById(section);
            if (featuredSection) {
                featuredSection.scrollIntoView({ behavior: "smooth" });
            }
        }
        OpenSidebar();
    };

    const handleClick = (link) => {
        setActiveLink(link);
    };

    const handleEnrollCourse = () => {
        const isUserLoggin = isLoggedIn();
        if (isUserLoggin) {
            OpenSidebar();
            accessCard();
            accessEnrollCourse();
        } else {
            accessCard();
            handleClick(null);
            OpenSidebar();
            accessCallReg();
        }
    }

    const check = () => {
        // console.log(getAllUsers());
        // removeDuplicateResults()
    }

    return (
        <div id='sidebar_container'>
            <div className={`left_sidebar ${openSidebarToggle ? "sidebar-open" : ""}`}>
                <div>
                    <h6 className='menu' onClick={check}>Main Menu</h6>
                    <ul className='navdata'>
                        <NavLink exact to='/' onClick={() => { handleClick('home'); handleScrollToFeatured('home-section'); }} className={({ isActive }) => `li ${isActive && activeLink === 'home' ? 'active red' : ''}`}><FaHome className='data_icon' />Home</NavLink>
                        <NavLink exact to='/' onClick={() => { handleClick('course'); handleScrollToFeatured('featured-section'); }} className={({ isActive }) => `li ${isActive && activeLink === 'course' ? 'active red' : ''}`}><IoIosSchool className='data_icon' />Popular Courses</NavLink>
                        <NavLink exact to='/course' onClick={() => { OpenSidebar(); }} className={({ isActive }) => `li ${isActive ? 'active' : ''}`}><IoIosSchool className='data_icon' />Courses</NavLink>
                        <NavLink exact to='/' onClick={() => { handleClick('enroll'); handleEnrollCourse(); }} className={({ isActive }) => `li ${isActive && activeLink === 'enroll' ? 'active red' : ''}`}><IoIosSchool className='data_icon' />Enrolled courses</NavLink>
                        <NavLink exact to='/' onClick={() => { handleClick('expert'); handleScrollToFeatured('expert-section'); }} className={({ isActive }) => `li ${isActive && activeLink === 'expert' ? 'active red' : ''}`}><FaFile className='data_icon' />Experts</NavLink>
                        <NavLink exact to='/notfound' onClick={() => { OpenSidebar(); }} className={({ isActive }) => `li ${isActive ? 'active' : ''}`}><MdLocalGroceryStore className='data_icon' />Store</NavLink>
                        <NavLink exact to='/' onClick={() => { handleClick('about'); handleScrollToFeatured('about-section'); }} className={({ isActive }) => `li ${isActive && activeLink === 'about' ? 'active red' : ''}`}><IoIosSchool className='data_icon' />About Us</NavLink>
                        <NavLink exact to='/terms-and-condition' onClick={OpenSidebar} className={({ isActive }) => `li ${isActive ? 'active' : ''}`}><FaFileImport className='data_icon' />Terms and Condition</NavLink>
                        <NavLink exact to='/privacy-policy' onClick={OpenSidebar} className={({ isActive }) => `li ${isActive ? 'active' : ''}`}><MdPrivacyTip className='data_icon' />Privacy Policy</NavLink>
                    </ul>
                </div>
            </div>
            <div className="content-container" onClick={() => { closeBar(); setOpen(false); }}>
                {toast && (
                    <Toast
                        message={toast.message}
                        type={toast.type}
                        onClose={() => setToast(null)}
                    />
                )}

                <div className={`signup ${card ? "Showcallreg" : "close"}`}>
                    <Card
                        handleClick={handleClick}
                        enroll={enroll}
                        accessEnrollCourse={accessEnrollCourse}
                        accessCallReg={accessCallReg}
                        showCallReg={showCallReg}
                        accessCard={accessCard}
                    />
                </div>
                <div className='content'>
                    <Content />
                </div>
                {showProfile && (
                    <div className="profile-overlay">
                        <Editprofile />
                    </div>
                )}
                {google && (
                    <div className="google-overlay">
                        <GoogleLoginCard />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Sidebar;